export default "__VITE_ASSET__CtLO3z9D__"